import { jsx, jsxs } from 'react/jsx-runtime';
import { Skeleton, SkeletonTypes } from '@promo-platform/skeleton';
var SkeletonBlock = function SkeletonBlock(_ref) {
  var _ref$amount = _ref.amount,
    amount = _ref$amount === void 0 ? 1 : _ref$amount;
  var blocksQuantityArray = Array.from(Array(amount).keys());
  return jsx("section", Object.assign({
    className: "skeleton-block-container"
  }, {
    children: blocksQuantityArray.map(function (item) {
      return jsxs("div", Object.assign({
        "data-testid": "skeleton-block",
        className: "skeleton-block"
      }, {
        children: [jsx(Skeleton, {
          type: SkeletonTypes.Subtitle
        }), jsx(Skeleton, {
          type: SkeletonTypes.Text,
          lines: 2
        }), jsx(Skeleton, {
          type: SkeletonTypes.Input
        })]
      }), item);
    })
  }));
};
export { SkeletonBlock };